export const exportEn = {
  csv: "Export to CSV",
  done: "%{smart_count} row exported. |||| %{smart_count} rows exported.",
  forbidden: "Export is limited to administrators.",
  failed: "Export failed. Try again.",
};
